// extracted by mini-css-extract-plugin
export var modal = "MenuModal-module--modal---jU6g";
export var close = "MenuModal-module--close--Kpi4I";